import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getFolders } from '../redux/folderActions';

type UseGetFoldersProps = {
  societyId?: string;
  currentFolderId?: string;
  page?: number;
  itemsPerPage?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
};

export const useGetFolders = ({
  societyId,
  currentFolderId,
  page = 1,
  itemsPerPage = 10,
  sortBy = 'position',
  sortOrder = 'desc',
}: UseGetFoldersProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchFolders = useCallback(
    async (controller: AbortController) => {
      if (!societyId) return;

      try {
        setIsLoading(true);

        await store.dispatch(
          getFolders({
            societyId,
            currentFolderId,
            params: {
              page,
              items: itemsPerPage,
              sortBy,
              sortOrder,
            },
            signal: controller.signal,
          })
        );

        if (!controller.signal.aborted) {
          setIsLoading(false);
        }
      } catch (error) {
        if (!controller.signal.aborted) {
          setIsLoading(false);
          setIsError(true);
        }
      }
    },
    [societyId, currentFolderId, page, itemsPerPage, sortBy, sortOrder]
  );

  useEffect(() => {
    const controller = new AbortController();

    fetchFolders(controller);

    return () => controller.abort();
  }, [fetchFolders]);

  return {
    isLoading,
    isError,
  };
};
